import { GET_SITE } from '@plone/volto/constants/ActionTypes';
import { getSite } from '@plone/volto/actions/site/site';

const getSiteAsyncPropExtender = {
  path: '/',
  extend: (dispatchActions) => {
    if (
      dispatchActions.filter((asyncAction) => asyncAction.key === GET_SITE)
        .length === 0
    ) {
      dispatchActions.push({
        key: GET_SITE,
        promise: ({ location, store: { dispatch } }) =>
          __SERVER__ && dispatch(getSite()),
      });
    }
    return dispatchActions;
  },
};

export { getSiteAsyncPropExtender };
